import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_zads5ze6zx: FaireBrandEntity = {
  token: "b_zads5ze6zx",
  type: "brand",
  name: "Bath bombs by jay",
  avatarUrl:
    "https://cdn.faire.com/fastly/e74c4e00f4826dc89642774e3e180860e3218aeb60b0430db82fceb3ae85ec97.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/abc6f7905396979f66c3c7c52f731cb06d09cf0118c0a5e15f62bce8927f9162.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/e74c4e00f4826dc89642774e3e180860e3218aeb60b0430db82fceb3ae85ec97.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/abc6f7905396979f66c3c7c52f731cb06d09cf0118c0a5e15f62bce8927f9162.jpeg",
  location: "Eastvale, CA, USA",
  minimumOrderDollars: 50,
  rating: 5,
  reviewCount: 4,
  isInsider: true,
  description:
    "Bath Bombs by Jay was born as a hobby, started with a small booth in a farmer's market post covid. Shortly, with the growing demand of the products, it turned into a full-fledged business dedicated into offering a product with all natural high end ingredients that help heals. ",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:52:08.500Z",
    importedBy: "entity-db-cli",
  },
};
